<ideal-product-quick-search-results
  *renderInAppQuickSearchResults
  [searchResults]="searchResults()"
  [searchTerm]="searchQuery()"
  [searchResultsMore]="searchResultsMore()"
></ideal-product-quick-search-results>
